import { render, staticRenderFns } from "./PagePersonalization.vue?vue&type=template&id=42eeea80&scoped=true&"
import script from "./PagePersonalization.vue?vue&type=script&lang=js&"
export * from "./PagePersonalization.vue?vue&type=script&lang=js&"
import style0 from "./PagePersonalization.vue?vue&type=style&index=0&id=42eeea80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42eeea80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42eeea80')) {
      api.createRecord('42eeea80', component.options)
    } else {
      api.reload('42eeea80', component.options)
    }
    module.hot.accept("./PagePersonalization.vue?vue&type=template&id=42eeea80&scoped=true&", function () {
      api.rerender('42eeea80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Common/NavbarMenu/components/SettingAndTools/PagePersonalization.vue"
export default component.exports